<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>

        <div class="vx-card__title mb-6">
          <h2 class="text-center">{{spaceTitle}} 클래스에</h2>
          <h2 class="text-center">프로젝트를 생성 합니다.</h2> &nbsp;
          <p class="text-center">하나의 클래스에 여러 프로젝트를 생성할 수 있어요 :)</p> <br>
        </div>

        <div class="centerx default-input">
          <vs-input class="mx-auto mb-2" icon-after="true"  icon="mode_edit" placeholder="프로젝트명을 입력하세요" v-model="projectName"/>
          <br>
          <img src="@/assets/images/pages/graphic-3.png" alt="CreateProject" class="mx-auto mb-2" width="250px" height="220px">
        <!-- <img src="@/assets/images/pages/rocket.png" alt="coming-soon" class="mx-auto mb-2" width="150">

        <div class="count-down text-center"> -->
          <!-- <countdown :time="new Date('03/09/2021 00:00:00').getTime() - new Date().getTime()">

            <template slot-scope="props">

              <div class="single-counter">
                <span class="timer">{{ props.days }}</span>
                <span>Days</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.hours }}</span>
                <span>Hours</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.minutes }}</span>
                <span>Minutes</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.seconds }}</span>
                <span>Seconds</span>
              </div>

            </template>
          </countdown> -->

        </div>
        <!-- <vs-divider position="center">클래스명</vs-divider> -->
        <div class="subscription" line-height="5px">
        <br>

          <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-4" /> -->

          <vs-button class="w-full" :disabled="!validateForm" @click="done()" >생성하기</vs-button>
          <br><br>
          <span>문의사항:mesen@filledyou.com</span>

        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
// import VueCountdown from '@chenfengyuan/vue-countdown'

export default {
  data() {
    return {
      spaceTitle: '',
      spaceId:0,
      projectName: '프로젝트 1조',
      projectDetail: ''
    }
  },
  created() {
    this.spaceTitle = this.$store.state.space.ActiveSpaceInfo.title
    this.spaceId = this.$store.state.space.ActiveSpaceInfo.id
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    activeWorkspaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    validateForm() {
      return !this.errors.any() && this.projectName != '';
    },
  },
  // components: {
  //   'countdown': VueCountdown
  // },
  methods: {
    acceptErrorAlert() {
        this.$router.push('/apps/space')
    },
    done() {    
      if (this.spaceId == 0){
        this.$vs.dialog({
          color: 'danger',
          title: '에러',
          text: '워크 스페이스를 다시 선택해 주세요.',
          accept: this.acceptErrorAlert
        })
      }
      else {
        const payload = {
          workspaceId: this.spaceId,
          title: this.projectName,
          detail: this.projectDetail
        }
        this.$store.dispatch('project/createProject', payload)
        .then((resolve)=>{
          if(resolve.data.result == 'success'){
            this.$vs.notify({
              color: 'success',
              title: '생성 완료'
            })
            this.$router.push('/pages/project/invite')
          }
        })
      }
    }
  }
}

</script>
<style lang="stylus">
  .default-input
  .vs-input
    margin-top 10px
    margin-bottom 10px
</style>
